<!--
2022-03-15 CHP 不再使用, 现在使用Account下面的bonus
-->
<template>
  <div class="page">
    <TopBack :title="$t('lang.wagering.title')"/>
    <div class="nav">
      <div class="nav-item" :class="{active: type==='claim'}" @click="type = 'claim'">{{$t('lang.account.claimBonus')}}</div>
      <div class="nav-item" :class="{active: type==='rules'}" @click="type = 'rules'">{{$t('lang.account.bonusRequirement')}}</div>
    </div>
    <div class="tab" v-show="type==='claim'">
      <div class="row">
        <div class="caption">
          <span>{{$t('lang.account.bonus')}}</span>
          <span>{{$t('lang.account.completedBonus')}}</span>
        </div>
        <div class="inputRow">
          <div>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.Bonus)}}</div>
          <div>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.ReadyToConvertBonus)}}</div>
        </div>
        <div class="inputRow">
          <div class="claim" @click="toClaimBonus">{{$t('lang.account.claim')}}</div>
        </div>
        <div class="splitter"></div>
        <div class="title" style="font-size: 16px; font-weight: bold">
          <span>{{ $t('lang.account.howDoesBonusWork') }}</span>
        </div>
        <div class="rules">
          <div v-for="(item, index) in $t('lang.account.howDoesBonusWorkItems')"
               :key="index">
            <div class="rule-item">
              <div class="rule-number">
                <span>{{index+1}}</span>
              </div>
              <div class="rule-content">
                <div class="rule-title">
                  <span>{{item}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab" v-show="type==='rules'">
      <div class="title" style="font-size: 16px; font-weight: bold">
        <span>{{ $t('lang.account.whatIsBonus') }}</span>
      </div>
      <div class="content" v-html="$t('lang.account.whatIsBonusContent')"></div>
      <div class="title">
        <span>{{ $t('lang.wagering.promptAll') }}</span>
      </div>
      <div class="list-wrapper">
        <div class="list-item item-header">
          <div class="name">
            <span>{{ $t('lang.wagering.name') }}</span>
          </div>
          <div class="provider">
            <span>{{ $t('lang.wagering.provider') }}</span>
          </div>
          <div class="wagering">
            <span>{{ $t('lang.wagering.wagering') }}</span>
          </div>
        </div>
        <div  class="list-item"
              v-for="(item, index) in gamesWagering"
              :key="index" v-if="item.Wagering > 0">
          <div class="name">
            <span>{{item.Name}}</span>
          </div>
          <div class="provider">
            <span>{{item.Provider}}</span>
          </div>
          <div class="wagering">
            <span>{{item.Wagering}}X</span>
          </div>
        </div>
      </div>
      <div class="title">
        <span>{{ $t('lang.wagering.promptFollowing') }}</span>
      </div>
      <div class="list-wrapper">
        <div  class="list-item"
              v-for="(item, index) in gamesWagering"
              :key="index" v-if="item.Wagering == 0">
          <div class="name">
            <span>{{item.Name}}</span>
          </div>
          <div class="provider">
            <span>{{item.Provider}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBack from '@/components/TopBack/index'
import request from '@/service'
import {Toast} from 'mint-ui'
import {separateThousand} from '@/utils'
import {fetchCurrency} from '@/constant'

export default {
  name: 'bonus',
  components: {
    TopBack
  },
  data () {
    return {
      type: 'claim',
      gamesWagering: [],
      fetchCurrency,
      separateThousand,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      accountInfo: {}
    }
  },
  mounted () {
    this.fetchAccount()
    this.getGamesWagering()
  },
  methods: {
    getGamesWagering: function () {
      const url = '/innovation/game/getgamewagering'
      const data = {
      }
      request('post', url, data).then(res => {
        this.gamesWagering = res.GamesWageringList
      })
    },
    /****
     * 2022-01-01 CHP 领取Bonus（支持部分领取）
     * */
    toClaimBonus () {
      if (!this.accountInfo.ReadyToConvertBonus ||
        this.accountInfo.ReadyToConvertBonus === 0) {
        Toast(this.$t('lang.account.noBonusReadyForClaim'))
        return
      }

      const url = '/innovation/account/convertuserbonus'
      const data = {
        userId: this.userInfo.UserId,
        bonusToConvert: this.accountInfo.ReadyToConvertBonus
      }
      request('post', url, data).then(res => {
        console.log(res)
        if (res.Code === 1) {
          this.accountInfo = {
            ...this.accountInfo,
            ...res
          }
          // Toast(this.$t('lang.common.success'))
          Toast(this.$t('lang.account.convertBonusSuccess_1') +
                ' ' + this.fetchCurrency[this.userInfo.CurrencyName] + res.ConvertedBonus + ' ' +
            this.$t('lang.account.convertBonusSuccess_2'))
        } else {
          Toast(this.$t('lang.common.fail'))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    fetchAccount () {
      if (this.userInfo) {
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: this.userInfo.UserId
        }
        request('post', url, data).then(res => {
          console.log(res)
          this.accountInfo = res
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (to.query.type) {
        vm.type = to.query.type
      }
    })
  }
}
</script>

<style lang="less" scoped>
  .page {
    padding: 30px 16px 100px 16px;
    color: #FFFFFF;

    .title {
      font-size: 14px;
      margin: 15px 0px;
      color: #f6d9aa;
    }

    .content {
      font-size: 14px;
      line-height: 24px;
      color: #EFEFEF;
    }

    .nav{
      display: flex;
      margin: 15px 0px 20px 0px;
      justify-content: space-around;
      font-weight: bold;
      /* border-radius: 6px;
      border: 1px solid rgba(246, 217,170, 0.5); */

      .nav-item{
        flex: 1;
        line-height: 30px;
        text-align: center;
        color: rgba(246, 217, 170, 0.5);
        width: 120px;
      }

      .active{
        width: 120px;
        /*background: #F6D9AA;*/
        /*color: #543200;*/
        /*border-radius: 6px;*/
        border-bottom: 2px solid #F6D9AA;
        color: #F6D9AA;
      }
    }

    .list-wrapper {
      .item-header {
        font-size: 14px;
        font-weight: bold;
        color: #f6d9aa;
      }

      .list-item {
        display: flex;
        font-size: 12px;
        line-height: 20px;
        border-bottom: #686868 solid 1px;

        .name {
          white-space: nowrap;
          overflow: hidden;
          flex: 2;
          margin-right: 5px;
        }

        .provider {
          white-space: nowrap;
          overflow: hidden;
          flex: 2;
        }

        .wagering {
          white-space: nowrap;
          flex: 1;
          text-align: center;
        }
      }
    }

    .row {
      margin-bottom: 30px;
      &:last-child {
        margin-bottom: 0;
      }
      .inputRow, .btnRow {
        div {
          line-height: 40px;
          border: 1px solid rgba(246, 217, 170, 0.5);
          border-radius: 6px;
        }
      }
      .inputRow {
        display: flex;
        &:not(:last-child) {
          /*margin-bottom: 16px;*/
          margin-bottom: 8px;
        }
        div {
          flex: 1;
          font-size: 16px;
          color: #fff;
          text-align: right;
          padding-right: 15px;
          &:not(:first-child) {
            margin-left: 9px;
          }
          input {
            font-size: 16px;
            color: #fff;
            text-align: right;
          }
        }
        .selected {
          font-size: 20px;
          font-weight: 600;
          color: #000;
          background-color: #F6D9AA;
        }
        .claim {
          text-align: center;
          color:#000000;
          background-color: #F6D9AA;
          font-size: 18px;
          padding: 0;
        }
      }
      .caption {
        font-size: 14px;
        line-height: 21px;
        color: #F6D9AA;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
      }
    }

    .splitter {
      border-bottom: #F6D9AA 1px solid;
      margin: 15px 0px;
    }

    .rules{
      .rule-item{
        display: flex;
        margin-bottom: 10px;
        .rule-number{
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 1px solid #F6D9AA;
          text-align: center;
          line-height: 40px;
          font-size: 20px;
          color: #F6D9AA;
        }
        .rule-content{
          width: calc(100vw - 32px - 40px);
          padding: 0 0px 0 10px;
          .rule-title{
            color: #F6D9AA;
            font-size: 16px;
            line-height: 20px;
            margin: 0 0 5px 0;
          }
          .rule-description{
            color: #DADADA;
            font-size: 14px;
            line-height: 20px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Games/bonus.vue